import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import { useMyContext } from "../contextProvider/contentTypeProvider";

const Dashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const data = [
    {
      name: "Area Of Interest",
      link: "/dashboard/aoi",
    },
    {
      name: "Business",
      link: "/dashboard/business",
    },
    {
      name: "Lifestyle",
      link: "/dashboard/lifestyle",
    },
    {
      name: "Coupons",
      link: "/dashboard/coupons",
    },
    // {
    //   name: "Users",
    //   link: "/dashboard/users",
    // },
    {
      name: "C-Suite Users",
      link: "/dashboard/c-suite",
    },
    {
      name: "Announcements",
      link: "/dashboard/announcements",
    },
    {
      name: "Users",
      link: "/dashboard/users",
    },
    {
      name: "Designations",
      link: "/dashboard/designation",
    },
    {
      name: "Connection Reasons",
      link: "/dashboard/connection-reasons",
    },
    {
      name: "Email Templates",
      link: "/dashboard/email-templates",
    },
  ];

  const { contextState, updateContextState } = useMyContext();

  return (
    <div>
      <Header />
      <div
        style={{
          display: "flex",
        }}
      >
        <div
          style={{
            width: "200px",
            display: "flex",
            flexDirection: "column",
            height: "100vh",
            // justifyContent: "center",
            gap: "10px",
            position: "fixed",
            border: "0px solid red",
            padding: "8px",
          }}
          className="bg-dark"
        >
          {data.map((d) => (
            <button
              onClick={() => {
                if (d.link.includes("business")) {
                  updateContextState({
                    business: { type: "news", status: "Active" },
                  });
                } else {
                  updateContextState({ lifestyle: { status: "Active" } });
                }
                navigate(d.link);
              }}
              key={d.name}
              className={`text-start btn btn-dark ${
                location.pathname === d.link ? "active" : ""
              }`}
            >
              {d.name}
            </button>
          ))}
        </div>
        <div
          id="detail"
          style={{
            width: "calc(100vw - 200px)",
            padding: "10px",
            marginLeft: "200px",
            height: "calc(100vh - 50px)",
            overflowY: "auto",
          }}
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
